import { lazy } from 'react';

export const OrdersPageAsync = lazy(() => import('./OrdersPage'));
